<template>
  <div class="contentRight" style="padding:0;width: calc(100vw - 217px);">
    <div class="head row">
      <div class="shopName">{{$store.state.shopInformation.shopName}}</div>
      <!-- <div class="state center">打烊</div>
      <div class="vip center">VIP</div> -->
      <!-- <form
        action="http://192.168.1.33:8888/ImageServer/YmUpload_image"
        method="post"
        enctype="multipart/form-data"
        name="form1"
        id="form1"
      >
        <input type="file" name="file" />
        <input type="submit" name="Submit" va1ue1="提交" />
      </form>-->
    </div>
    <div class="content">
      <!-- 四张图 -->
      <div class="row">
        <div class="rectangle img1">
          <div class="text1">累计金额（元）</div>
          <div class="text2">{{grandTotal.money}}</div>
        </div>
        <div class="rectangle img2">
          <div class="text1">累计订单数（笔）</div>
          <div class="text2">{{grandTotal.orderNum}}</div>
        </div>
        <div class="rectangle img3">
          <div class="text1">累计人均消费（元）</div>
          <div class="text2">{{grandTotal.customerMoney}}</div>
        </div>
        <div class="rectangle img4">
          <div class="text1">累计新增会员数</div>
          <div class="text2">{{grandTotal.newShopMemberNum}}</div>
        </div>
      </div>
      <!-- 销售概况 -->
      <div class="topPlate">
        <h5>销售概况</h5>
        <div class="row topPlate-content">
          <div class="topPlate-items">
            <div class="text3">今日收益金额(元)</div>
            <div class="text4">{{toDay.money}}</div>
          </div>
          <div class="topPlate-items">
            <div class="text3">今日订单数</div>
            <div class="text4">{{toDay.orderNum}}</div>
          </div>
          <div class="topPlate-items">
            <div class="text3">待付款订单</div>
            <div class="text4">{{toDay.noPayOrderNum }}</div>
          </div>
          <div class="topPlate-items">
            <div class="text3">退款订单数</div>
            <div class="text4">{{toDay.backOrderNum }}</div>
          </div>
        </div>
      </div>
      <!-- 常用功能 -->
      <div class="topPlate">
        <h5>常用功能</h5>
        <div class>
          <div class="row topPlate-content" style="flex-wrap: wrap;">
            <div @click="jumpTT('commodity',true)" class="topPlate-items row alignCenter">
              <img src="../../assets/icon/xjsp.png" alt />
              <div class="text5">新建商品</div>
            </div>
            <div @click="jumpTT('bill')" class="topPlate-items row alignCenter">
              <img src="../../assets/icon/zdmx2.png" alt />
              <div class="text5">账单明细</div>
            </div>
            <div @click="jumpTT('information')" class="topPlate-items row alignCenter">
              <img src="../../assets/icon/jrsj.png" alt />
              <div class="text5">今日数据</div>
            </div>
            <div @click="jumpTT('set')" class="topPlate-items row alignCenter">
              <img src="../../assets/icon/mdgl.png" alt />
              <div class="text5">门店管理</div>
            </div>
            <div @click="jumpTT('orderManagment')" class="topPlate-items margin-10 row alignCenter">
              <img src="../../assets/icon/ddxq.png" alt />
              <div class="text5">订单列表</div>
            </div>
            <div @click="jumpTT('customer')" class="topPlate-items margin-10 row alignCenter">
              <img src="../../assets/icon/khgl2.png" alt />
              <div class="text5">会员管理</div>
            </div>
            <div @click="jumpTT('customer',true)" class="topPlate-items margin-10 row alignCenter">
              <img src="../../assets/icon/xjhyk.png" alt />
              <div class="text5">新建会员卡</div>
            </div>
            <div @click="jumpTT('set','second')" class="topPlate-items margin-10 row alignCenter">
              <img src="../../assets/icon/yggl.png" alt />
              <div class="text5">员工管理</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 交易趋势 -->
      <div class="topPlate">
        <div
          class="bottomTitle row alignCenter"
          style="display:flex;justify-content: space-between;"
        >
          <h5>交易趋势</h5>
          <div class="row alignCenter">
            <el-select size="small" @change="shopChange()" v-model="value" placeholder="请选择">
              <el-option
                v-for="item in shopList"
                :key="item.storeName"
                :label="item.storeName"
                :value="item.shopStoreId"
              ></el-option>
            </el-select>
            <div class="totot"></div>
            <el-select size="small" @change="shopChange()" v-model="value2" placeholder="请选择">
              <el-option
                v-for="item in options2"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
            <div class="totot"></div>
            <div class="block" v-show="this.value2 == '季度'">
              <el-date-picker
                v-model="value5"
                type="monthrange"
                unlink-panels
                size="small"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="dateChange('threeMonth')"
                value-format="yyyy-MM"
                :picker-options="pickerOptions2"
              ></el-date-picker>
            </div>

            <div class="block" v-show="this.value2 == '周'">
              <el-date-picker
                v-model="value3"
                type="daterange"
                unlink-panels
                size="small"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="dateChange('week')"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </div>
            <div class="block" v-if="this.value2 == '月'">
              <div class="block">
                <el-date-picker
                  @change="dateChange('month')"
                  value-format="yyyy-MM"
                  v-model="value4"
                  type="month"
                  size="small"
                  placeholder="选择月"
                ></el-date-picker>
              </div>
            </div>
            <div class="block" v-if="this.value2 == '日'">
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="value1"
                type="date"
                @change="dateChange('date')"
                size="small"
                placeholder="选择日期"
              ></el-date-picker>
            </div>
          </div>
        </div>
        <div style="margin-top:20px;margin-left:10px;">
          <div class="row">
            <div @click="tep1" :class="checked?'tep':'tep2'">
              <div class="tepTitle">
                交易金额（元）
                <!-- <el-checkbox v-model="checked"></el-checkbox> -->
                <div class="center" style="cursor: pointer">
                  <img v-if="!checked" src="../../assets/icon/wx.png" alt />
                  <img v-if="checked" src="../../assets/icon/qx.png" alt />
                </div>
              </div>
              <h3 class="tepPrice">{{ShopStoreStatistic.money}}</h3>
              <div class="tepText row">
                <div>较前一日</div>
                <div
                  v-if="ShopStoreStatistic.orderNumDayPercent"
                >{{ShopStoreStatistic.moneyDayPercent}}%-</div>

                <div v-else>无</div>
              </div>
              <div class="tepText row">
                <div>较上周同期</div>
                <div
                  v-if="ShopStoreStatistic.orderNumWeekPercent"
                >{{ShopStoreStatistic.moneyWeekPercent}}%-</div>
                <div v-else>无</div>
              </div>
            </div>
            <div @click="tep2" :class="checked2?'tep':'tep2'">
              <div class="tepTitle">
                新增会员数
                <div class="center" style="cursor: pointer">
                  <img v-if="!checked2" src="../../assets/icon/wx.png" alt />
                  <img v-if="checked2" src="../../assets/icon/qx.png" alt />
                </div>
                <!-- <el-checkbox v-model="checked2"></el-checkbox> -->
              </div>
              <h3 class="tepPrice">{{ShopStoreStatistic.newShopMemberNum}}</h3>
              <div class="tepText row">
                <div>较前一日</div>
                <div
                  v-if="ShopStoreStatistic.newShopMemberNumDayPercent"
                >{{ShopStoreStatistic.newShopMemberNumDayPercent}}%-</div>
                <div v-else>无</div>
              </div>
              <div class="tepText row">
                <div>较上周同期</div>
                <div
                  v-if="ShopStoreStatistic.newShopMemberNumWeekPercent"
                >{{ShopStoreStatistic.newShopMemberNumWeekPercent}}%-</div>
                <div v-else>无</div>
              </div>
            </div>
            <div @click="tep3" :class="checked3?'tep':'tep2'">
              <div class="tepTitle">
                增加订单数
                <div class="center" style="cursor: pointer">
                  <img v-if="!checked3" src="../../assets/icon/wx.png" alt />
                  <img v-if="checked3" src="../../assets/icon/qx.png" alt />
                </div>
                <!-- <el-checkbox v-model="checked3"></el-checkbox> -->
              </div>
              <h3 class="tepPrice">{{ShopStoreStatistic.orderNum}}</h3>
              <div class="tepText row">
                <div>较前一日</div>
                <div
                  v-if="ShopStoreStatistic.moneyDayPercent"
                >{{ShopStoreStatistic.orderNumDayPercent}}%-</div>
                <div v-else>无</div>
              </div>
              <div class="tepText row">
                <div>较上周同期</div>
                <div
                  v-if="ShopStoreStatistic.moneyWeekPercent"
                >{{ShopStoreStatistic.orderNumWeekPercent}}%-</div>
                <div v-else>无</div>
              </div>
            </div>
          </div>
          <!-- 映射文字 -->
          <div class="row">
            <div v-if="checked" class="map row alignCenter">
              <div class="circle"></div>
              <div class="mapText">交易金额</div>
            </div>
            <div v-if="checked2" class="map row alignCenter">
              <div class="circle1"></div>
              <div class="mapText">新增会员数</div>
            </div>
            <div v-if="checked3" class="map row alignCenter">
              <div class="circle2"></div>
              <div class="mapText">增加订单数</div>
            </div>
          </div>
          <!-- 统计图 -->
          <div :id="id" style="width: 100%;height:260px;"></div>
        </div>
      </div>
      <div class="center" style="margin-top:20px">
        <img src="../../assets/icon/qrc2.png" alt />
      </div>
    </div>
  </div>
</template>


<script>
import echarts from "echarts";
export default {
  name: "home",

  data() {
    var vue = this;
    return {
      pickerOptions: {
        disabledDate(time) {
          let timeOptionRange = vue.timeOptionRange;
          let secondNum = 60 * 60 * 24 * 7 * 1000;
          if (timeOptionRange) {
            return (
              time.getTime() > timeOptionRange.getTime() + secondNum ||
              time.getTime() < timeOptionRange.getTime() - secondNum
            );
          }
        },
        onPick(time) {
          //当第一时间选中才设置禁用
          if (time.minDate && !time.maxDate) {
            vue.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            vue.timeOptionRange = null;
          }
        }
      },
      pickerOptions2: {
        disabledDate(time) {
          let timeOptionRange = vue.timeOptionRange;
          let secondNum = 60 * 60 * 24 * 90 * 1000;
          if (timeOptionRange) {
            return (
              time.getTime() > timeOptionRange.getTime() + secondNum ||
              time.getTime() < timeOptionRange.getTime() - secondNum
            );
          }
        },
        onPick(time) {
          //当第一时间选中才设置禁用
          if (time.minDate && !time.maxDate) {
            vue.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            vue.timeOptionRange = null;
          }
        }
      },
      id: "main",
      grandTotal: [], //累计数据
      toDay: [], //今日数据
      price: "31.00",
      checked: true, //控制交易趋势里的点击状态
      checked2: false, //控制交易趋势里的点击状态
      checked3: false, //控制交易趋势里的点击状态
      shopList: [
        { storeName: "全部门店", shopStoreId: "" }
        //门店地址数组
      ],
      options2: [
        { name: "日" },
        { name: "周" },
        { name: "月" },
        { name: "季度" }
      ],
      value2: "日", //日默认
      value3: "", //日默认
      value4: "", //日默认
      value5: "", //日默认
      value: "全部门店", //门店默认
      value1: "", //日期默认
      echartsArr: [], //统计表数组
      timeList: [], //统计表时间数组
      ShopStoreStatistic: "", //经营分析
      editList: []
    };
  },

  watch: {
    echartsArr: function() {
      let main = document.getElementById("main");
      var myChart = echarts.init(main);
      myChart.clear();
      this.myChart();
     
    },
    value: function() {
      var myDate = new Date();
      myDate.getYear(); //获取当前年份(2位)
      var month = myDate.getMonth() + 1;
      let str = myDate.getFullYear() + "-" + month + "-" + myDate.getDate();
      var id = this.value;
      var date = this.value1;
      if (!this.value1) {
        date = str;
      }
      if (this.value == "全部门店") {
        id = "";
      }
      this.MallOrder_findShopStoreStatistic(date, id);
    }
  },

  created() {
    var id = this.value;
    if (this.value == "全部门店") {
      id = "";
    }
    var myDate = new Date();
    myDate.getYear(); //获取当前年份(2位)
    var month = myDate.getMonth() + 1;
    let str = myDate.getFullYear() + "-" + month + "-" + myDate.getDate();
    var endDate = myDate.getDate() - 6;
    console.log(endDate, 'endDate')
    var str2 = myDate.getFullYear() + "-" + month + "-" + endDate;

    let userList = JSON.parse(this.getCookie("userList"));
    this.userList = userList;
    console.log(this.userList, "this.userList")

    //获取店铺信息
    this.request
      .post("qrcapi/Shop_shopInfo", {
        sessionId: this.userList.sessionId,
        userId: this.userList.id
      })
      .then(res => {
        if (res.code == 1) {
          this.setCookie("shopInformation", JSON.stringify(res.data));
          this.$store.state.shopInformation = res.data;
          this.shopInformation = res.data;
        } else if (res.code == 2) {
          this.$router.push('/')
          this.$message.error(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      })
      .catch(function(error) {
      });
    // let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    // this.shopInformation = shopInformation;

    this.request
      .post("qrcapi/MallOrder_getCumulative", {
        sessionId: this.userList.sessionId,
        userId: this.userList.id
      })
      .then(res => {
        // console.log(res,'MallOrder_getCumulative');
        if (res.code == 1) {
          // this.$message({
          //   message: res.msg,
          //   type: "success"
          // });
          this.grandTotal = res.data;
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    //交易趋势--每天的交易金额，支付订单数
    this.request
      .post("qrcapi/MallOrder_getTodayStatistic", {
        sessionId: this.userList.sessionId,
        userId: this.userList.id
      })
      .then(res => {
        if (res.code == 1) {
          // this.$message({
          //   message: res.msg,
          //   type: "success"
          // });
          this.toDay = res.data;
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });

    //经营分析
    this.MallOrder_findShopStoreStatistic2(str, id, str);
    this.cartogram(str, str, id, true);
    this.Shop_shopStores(); //门店列表
    function sleep (ms){
      return new Promise((resolve,reject)=>{
            let dice = Math.random()*6+1
            setTimeout(resolve(dice),ms)
           
      })
    }
    async function hild(){
      let mode = await sleep(2000)
      console.log(mode,'result')
    }
    hild()
  },

  mounted() {
    //添加统计图
    this.myChart();
  },

  methods: {
    //监听门店改变
    shopChange() {
      this.value3 = "";
      this.value4 = "";
      this.value5 = "";
    },
    //统计图
    cartogram(startDate, endDate, id, first) {
      this.request
        .post("qrcapi/MallOrder_getQueryDailyBargain", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          shopStoreId: id, //门店id
          startDate: startDate, //筛选开始时间
          endDate: endDate //结束时间
        })
        .then(res => {
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
            if (first) {
              this.echartsArr.push({
                data: res.data.money,
                type: "line",
                smooth: true,
                name: "交易金额"
              });
            } else {
              this.checked = true;
              this.checked2 = true;
              this.checked3 = true;
              if (this.checked && this.checked2 && this.checked3) {
                this.echartsArr = [
                  {
                    data: res.data.money,
                    type: "line",
                    smooth: true,
                    name: "交易金额"
                  },
                  {
                    data: res.data.orderNums,
                    type: "line",
                    smooth: true,
                    name: "增加订单数"
                  },
                  {
                    data: res.data.newShopMemberNums,
                    type: "line",
                    smooth: true,
                    name: "新增会员数"
                  }
                ];
              }
            }
            this.timeList = res.data.dates;
            this.editList = res.data;

            let main = document.getElementById("main");
          
            var myChart = echarts.init(main);
            myChart.clear();
            this.myChart();
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //经营分析
    MallOrder_findShopStoreStatistic(startDate, shopStoreId) {
      this.request
        .post("qrcapi/MallOrder_findShopStoreStatistic", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          shopStoreId: shopStoreId, //门店id
          startDate: startDate, //筛选开始时间
          endDate: startDate //结束时间
        })
        .then(res => {
         
          this.ShopStoreStatistic = res.data;
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //经营分析
    MallOrder_findShopStoreStatistic2(startDate, shopStoreId, endDate) {
      this.request
        .post("qrcapi/MallOrder_findShopStoreStatistic", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          shopStoreId: shopStoreId, //门店id
          startDate: startDate, //筛选开始时间
          endDate: endDate //结束时间
        })
        .then(res => {
          
          this.ShopStoreStatistic = res.data;
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //门店列表
    Shop_shopStores(pageNo) {
      this.request
        .post("qrcapi/Shop_shopStores", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          pageNo: pageNo,
          row: 10
        })
        .then(res => {
          if (res.code == 1) {
     
            for (let i in res.data.list) {
              this.shopList.push(res.data.list[i]);
            }
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //跳转
    jumpTT(adress, message) {
      // this.$router.push(adress)
      this.$router.push({ path: adress, query: { docId: message } });
    },
    // 控制交易金额交易趋势方框
    tep1() {
      this.checked = !this.checked;
      if (!this.checked) {
        for (let i in this.echartsArr) {
          if (this.echartsArr[i].name == "交易金额") {
            this.echartsArr.splice(i, 1);
          }
        }
      } else {
        this.echartsArr.push({
          data: this.editList.money,
          type: "line",
          smooth: true,
          name: "交易金额"
        });
      }
    },
    // 控制订单交易趋势方框
    tep3() {
      this.checked3 = !this.checked3;
      if (!this.checked3) {
        for (let i in this.echartsArr) {
          if (this.echartsArr[i].name == "增加订单数") {
            this.echartsArr.splice(i, 1);
          }
        }
      } else {
        this.echartsArr.push({
          data: this.editList.orderNums,
          type: "line",
          smooth: true,
          name: "增加订单数"
        });
      }
    },
    // 控制会员交易趋势方框
    tep2: function() {
      this.checked2 = !this.checked2;
      if (!this.checked2) {
        for (let i in this.echartsArr) {
          if (this.echartsArr[i].name == "新增会员数") {
            this.echartsArr.splice(i, 1);
          }
        }
      } else {
        this.echartsArr.push({
          data: this.editList.newShopMemberNums,
          type: "line",
          smooth: true,
          name: "新增会员数"
        });
      }
      // this.echartsArr.splice(0,1)
    },
    //监听日期下拉框
    dateChange(e) {
      var id = this.value;
      if (this.value == "全部门店") {
        id = "";
      }
      var d = new Date(2018, 6, 0);
      if (e == "week") {
        let str = this.value3[0];
        let dar = this.value3[1];
        this.cartogram(str, dar, id);
        this.MallOrder_findShopStoreStatistic2(str, id, dar);
      } else if (e == "date") {
        this.MallOrder_findShopStoreStatistic(this.value1, id);
      } else if (e == "month") {
        let str = this.value4 + "-" + "1";
        let dar = this.value4 + "-" + "31";
        this.cartogram(str, dar, id);
        this.MallOrder_findShopStoreStatistic2(str, id, dar);
      } else if (e == "threeMonth") {
        let str = this.value5[0] + "-" + "1";
        let dar = this.value5[1] + "-" + "31";
        this.cartogram(str, dar, id);
        this.MallOrder_findShopStoreStatistic2(str, id, dar);
      }
    },
    //添加统计图
    myChart() {
      var myDate = new Date();
      var month = myDate.getMonth() + 1;
      var day = myDate.getDate() + 1;
      let date = month + "-" + day;
      // 统计图   #c23531
      let main = document.getElementById("main");
      var myChart = echarts.init(main);
      myChart.setOption({
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          type: "category",
          data: this.timeList
        },
        yAxis: {
          type: "value"
        },
        series: this.echartsArr
      });
    }
  }
};
</script>

<style scoped>
.head {
  background: #fff;
  height: 66px;
  border-bottom: 2px solid #f5f5f5;
  box-sizing: border-box;
  padding: 20px 0 0 30px;
}
.state {
  height: 24px;
  width: 40px;
  background: #108ee9;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  margin-left: 20px;
  margin-top: 5px;
}
.vip {
  height: 24px;
  width: 40px;
  background: #fff;
  color: #108ee9;
  border-radius: 4px;
  font-size: 14px;
  margin-left: 10px;
  margin-top: 5px;
}
.shopName {
  font-size: 25px;
}
.rectangle {
  height: 125px;
  width: 23.5%;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
}
.rectangle:not(:first-child) {
  margin-left: 2%;
}
.img1 {
  background: url(../../assets/icon/ljje.png) no-repeat;
  background-size: 100%;
}
.img2 {
  background: url(../../assets/icon/ljdds.png) no-repeat;
  background-size: 100%;
}
.img3 {
  background: url(../../assets/icon/ljrjxf.png) no-repeat;
  background-size: 100%;
}
.img4 {
  background: url(../../assets/icon/ljxzhys.png) no-repeat;
  background-size: 100%;
}
.text1 {
  color: #fff;
  font-size: 13px;
  margin-left: 22px;
  margin-top: 7%;
}
.text2 {
  color: #fff;
  font-size: 25px;
  margin-left: 22px;
  margin-top: 2%;
}
.content {
  box-sizing: border-box;
  padding:20px 30px 0 30px;
}
.topPlate {
  background: #fff;
  width: 100% - 32px;
  /* border-radius: 10px; */
  margin-top: 20px;
  padding: 16px;
}
.topPlate-items {
  width: 25%;
  cursor: pointer;
}
.topPlate-content {
  margin-top: 28px;
  margin-left: 15px;
  width: 100%;
}
.text3 {
  font-size: 12px;
}
.text4 {
  font-size: 22px;
  margin-top: 12px;
  margin-bottom: 10px;
}
.text5 {
  font-size: 13px;
  color: #858585;
  margin-left: 10px;
}
.margin-10 {
  margin-top: 10px;
  margin-bottom: 10px;
}
.bottomTitle {
  background: #f8f8f8;
  padding: 10px;
  border-radius: 10px;
}
.totot {
  width: 20px;
}
.tep {
  width: 130px;
  height: 100px;
  border: 1px solid #108ee9;
  border-radius: 10px;
  padding: 10px;
  margin-right: 10px;
  background: #e9f2ff;
}
.tep2 {
  width: 130px;
  height: 100px;
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 10px;
  margin-right: 10px;
}
.tepTitle {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.tepText {
  color: gray;
  justify-content: space-between;
  font-size: 13px;
}
.tepText:last-child {
  margin-top: 6px;
}
.tepPrice {
  margin: 10px 0;
}
.map {
  font-size: 14px;
  margin-top: 26px;
  color: gray;
}
.map:not(:first-child) {
  margin-left: 20px;
}
.circle {
  /* background: #108ee9; */
  background: #c23531;
  border-radius: 50%;
  height: 10px;
  width: 10px;
}
.circle1 {
  background: #2f4554;
  border-radius: 50%;
  height: 10px;
  width: 10px;
}
.circle2 {
  background: #61a0a8;
  border-radius: 50%;
  height: 10px;
  width: 10px;
}
.mapText {
  margin-left: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/home.vue